import type { z } from 'zod';

import type { PermissionGroupSchema } from './schemas';

type PermissionGroupField = keyof z.infer<typeof PermissionGroupSchema>;

const listAttributes = [
  'id',
  'type',
  'label',
  'users',
  'basePermissionIds',
  'currPermissionIds',
] as const satisfies readonly PermissionGroupField[];

const getAttributes = [...listAttributes] as const;

const updateAttributes = ['label'] as const satisfies readonly PermissionGroupField[];

export const PermissionGroupAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
